import CryptoJS from 'crypto-js'

/**
 * AES加密解密工具类
 */
export class AesUtil {
  private static readonly KEY = CryptoJS.enc.Utf8.parse('wkxiaolvsanKey&20250522Xiaolvsan') // 16位密钥
  private static readonly IV = CryptoJS.enc.Utf8.parse('wkxiaolvsanIv#20')  // 16位偏移量

  /**
   * AES加密
   * @param plainText 明文
   * @returns 加密后的Base64字符串
   */
  static encrypt(plainText: string): string {
   try{
    if(plainText == undefined || plainText == ""){
      return "";
    }
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(plainText),
      this.KEY,
      {
        iv: this.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    return encrypted.toString()
   }catch{
    return plainText;
   }
  }

  /**
   * AES解密
   * @param cipherText 密文(Base64格式)
   * @returns 解密后的原始字符串
   */
  static decrypt(cipherText: string): string {
    try{

      if(cipherText == undefined || cipherText == ""){
        return "";
      }
      var index = cipherText.indexOf("(走读)");
      var schooltype = "";
      if (index != -1)
      {
          var result = cipherText.substring(0, index);
          schooltype = "(走读)";
          cipherText = result;
      }

      var index1 = cipherText.indexOf("(住校)");
      if (index1 != -1)
      {
          var result = cipherText.substring(0, index1);
          schooltype = "(住校)";
          cipherText = result;
      }
      const decrypted = CryptoJS.AES.decrypt(
        cipherText,
        this.KEY,
        {
          iv: this.IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      )
      return decrypted.toString(CryptoJS.enc.Utf8)+schooltype
    }catch{
      return cipherText
    }
  }
  /**
   * 图片路径加认证
   * @param imgUrl 图片路径
   * @returns 加上认证返回的图片路径
   */
  static imgAddAuth(imgUrl:string):string{
    if(imgUrl == undefined || imgUrl == "")
      return "";
    try{
      return imgUrl+"?auth=wkxiaolvsan";
    }catch{
      return imgUrl;
    }
  }

  /**
   * 图片路径删除认证
   * @param imgUrl 图片路径
   * @returns 加上认证返回的图片路径
   */
  static imgDelAuth(imgUrl:string):string{
    if(imgUrl == undefined || imgUrl == "")
      return "";
    try{
      return imgUrl.replace("?auth=wkxiaolvsan","");
    }catch{
      return imgUrl;
    }
  }
}
